import { Dispatch, SetStateAction, createContext } from "react";
import { TissuePlacement } from "../../models";

export interface ITissuePlacementsContext {
    tissuePlacement: TissuePlacement | undefined;
    setTissuePlacement: Dispatch<SetStateAction<TissuePlacement | undefined>>;
    isFetching: boolean;
    setIsFetching: Dispatch<SetStateAction<boolean>>;
    isSaving: boolean;
    setIsSaving: Dispatch<SetStateAction<boolean>>;
    isLocked: boolean;
    lockedByName: string;
    unlock: (tissueId: number | string) => Promise<void>;
    sendPostopFollowup: (pin: string) => Promise<TissuePlacement | undefined>;
    isPostopFollowupSent: boolean;
}

const defaultValue: ITissuePlacementsContext = {
    tissuePlacement: undefined,
    setTissuePlacement: () => { },
    isFetching: false,
    setIsFetching: () => { },
    isSaving: false,
    setIsSaving: () => { },
    isLocked: false,
    lockedByName: "",
    unlock: async () => { },
    sendPostopFollowup: async () => undefined,
    isPostopFollowupSent: false,
};

export const TissuePlacementsContext = createContext<ITissuePlacementsContext>(defaultValue);
TissuePlacementsContext.displayName = "TissuePlacements";
